(function () {
  var root = document.documentElement;
  if (!root.classList.contains('page-reveal')) return;
  window.__pageReveal = true;

  // Keep in sync with the selector list in base.css.
  var SELECTOR = [
    // Homepage
    '.ed-kicker',
    '.ed-heading',
    '.pairings__sub',
    '.series-card',
    '.pairing',
    '.ed-steps__kicker',
    '.ed-steps__heading',
    '.ed-steps__item',
    '.ed-banner__content > *',
    '.cfeature__media',
    '.cfeature__content > *',
    '.collection__title',
    '.product-grid > .grid__item',
    '.collection__view-all',
    '.multicolumn .title-wrapper-with-link',
    '.multicolumn-list__item',
    // Product pages
    '.product__media-wrapper',
    '.product__info-container > *',
    '.frag-kicker',
    '.frag-heading',
    '.frag-sub',
    '.frag-occasions__sub',
    '.frag-story__media',
    '.frag-story__content > *',
    '.frag-note',
    '.frag-chips',
    '.frag-occasion',
    '.frag-formula__item',
    '.frag-formula__op',
    '.frag-cta',
    '.frag-table-wrap',
    '.collapsible-content__header',
    '.collapsible-content .accordion',
    '.related-products__heading',
    // Any custom section element marked for reveal (About page etc.)
    '[data-reveal]',
  ].join(',');

  var main = document.getElementById('MainContent');
  if (!main || !('IntersectionObserver' in window)) {
    root.classList.remove('page-reveal');
    return;
  }

  // Items that come into view together animate one after another, in reading order.
  // An item scrolled to on its own starts straight away.
  function revealGroup(elements) {
    elements.sort(function (a, b) {
      var ra = a.getBoundingClientRect();
      var rb = b.getBoundingClientRect();
      return Math.abs(ra.top - rb.top) > 24 ? ra.top - rb.top : ra.left - rb.left;
    });
    elements.forEach(function (el, index) {
      el.style.setProperty('--reveal-delay', Math.min(index, 5) * 0.08 + 's');
    });
    requestAnimationFrame(function () {
      elements.forEach(function (el) {
        el.classList.add('is-revealed');
      });
    });
  }

  var observer = new IntersectionObserver(
    function (entries) {
      var batch = [];
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var target = entry.target;
        if (target.classList.contains('slider')) {
          Array.prototype.push.apply(batch, target.querySelectorAll(SELECTOR));
        } else {
          batch.push(target);
        }
        observer.unobserve(target);
      });
      if (batch.length) revealGroup(batch);
    },
    { rootMargin: '0px 0px -6% 0px' }
  );

  var observedSliders = [];

  function setup(scope) {
    var items = Array.prototype.slice.call(scope.querySelectorAll(SELECTOR));
    if (scope !== main && scope.matches && scope.matches(SELECTOR)) items.unshift(scope);

    items.forEach(function (item) {
      if (item.dataset.revealReady) return;
      item.dataset.revealReady = 'true';

      // Product sliders scroll sideways, so reveal the whole row together.
      var slider = item.closest('.slider');
      if (slider) {
        if (observedSliders.indexOf(slider) === -1) {
          observedSliders.push(slider);
          observer.observe(slider);
        }
      } else {
        observer.observe(item);
      }
    });
  }

  setup(main);

  // Some sections (like "You may also like") load their content later.
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType === 1) setup(node);
        });
      });
    }).observe(main, { childList: true, subtree: true });
  }
})();
